import React, { FC } from "react";

import Form from "antd/es/form";
import { useIntl } from "react-intl";

import { LabeledSwitch } from "@app/component/input/LabeledSwitch";
import OrganizationSetting from "@app/enum/OrganizationSetting";

export interface SharedActivityVisibilityProps {}

const SharedActivityVisibility: FC<SharedActivityVisibilityProps> = () => {
  const intl = useIntl();

  return (
    <Form.Item name={OrganizationSetting.CROSS_OBJECT_ACTIVITY_VISIBILITY} valuePropName="checked">
      <LabeledSwitch
        description={intl.formatMessage({
          id: "settings.organizationDetails.activities.crossObjectActivityVisibility.switch.description",
          defaultMessage:
            "Enable this setting to allow members see all activities related to records they have access to. Disable it to prevent members from seeing other users’ activities, even on shared records.",
          description:
            "Settings organization details - Activities - Cross Object Activity Visibility - description",
        })}
        title={intl.formatMessage({
          id: "settings.organizationDetails.activities.crossObjectActivityVisibility.switch.title",
          defaultMessage: "Shared record activity visibility",
          description:
            "Settings organization details - Activities - Cross Object Activity Visibility - title",
        })}
      />
    </Form.Item>
  );
};

export default SharedActivityVisibility;
